import React from "react";

import { Box } from "@mui/system";
import { format } from "date-fns";
import { useParams } from "react-router-dom";

import useGetPortfolioPlanById from "@fartherfinance/frontend/api/Investment/hooks/useGetPortfolioPlanById";
import useGetPortfolioPlanPerformanceById from "@fartherfinance/frontend/api/Investment/hooks/useGetPortfolioPlanPerformanceById";
import { PortfolioPlanId } from "@fartherfinance/frontend/api/Types";

import BaseDrawer from "@src/multiCustodian/components/Advisor/Investments/ModelMarketplaceV2/PortfolioPlanTab/ModelDrawer/BaseDrawer/BaseDrawer";
import { whitelistTaxStatus } from "@src/multiCustodian/components/Advisor/Investments/ModelMarketplaceV2/PortfolioPlanTab/PortfolioData";
import ClassificationTable from "@src/multiCustodian/components/PortfolioPlanV2/ClassificationTable/ClassificationTable";
import HistoricPerformanceTable from "@src/multiCustodian/components/PortfolioPlanV2/HistoricalPerformance/HistoricalPerformance";
import ModelDetailsTable from "@src/multiCustodian/components/PortfolioPlanV2/ModelDrawer/ModelDetailsTable";
import useAdvisorRequestAuth from "@src/multiCustodian/hooks/useAdvisorRequestAuth";
import finScoreToLabel from "@src/multiCustodian/utils/finScoreToLabel";
import BookmarkButton from "@src/sharedComponents/BookmarkButton/BookmarkButton";

const formatCreateTime = (value?: Date) =>
  value !== undefined ? format(value, "M/d/yyyy") : "N/A";

const ModelDrawerV2: React.FC = () => {
  const { portfolioPlanId } = useParams<{
    portfolioPlanId: PortfolioPlanId;
  }>();

  const auth = useAdvisorRequestAuth();

  const {
    data: portfolioPlan,
    isLoading: isLoadingPortfolioPlan,
    hasError: hasErrorPortfolioPlan,
  } = useGetPortfolioPlanById(portfolioPlanId, {}, auth);

  const portfolioPlanPerformance = useGetPortfolioPlanPerformanceById(
    portfolioPlanId,
    auth
  );

  const parsedFinScore = finScoreToLabel(
    portfolioPlanPerformance.data?.data.finscore?.toNumber()
  );

  return (
    <BaseDrawer>
      <ModelDetailsTable
        hasError={hasErrorPortfolioPlan}
        isLoading={isLoadingPortfolioPlan}
        riskLabel={parsedFinScore}
        createTime={formatCreateTime(portfolioPlan?.data.plan.createdAt)}
        taxLabel={whitelistTaxStatus(portfolioPlan?.data.plan.tags)}
        portfolioId={portfolioPlanId}
      />
      <HistoricPerformanceTable {...portfolioPlanPerformance} />
      <ClassificationTable portfolioPlanId={portfolioPlanId} />
      <Box style={{ alignSelf: "flex-end" }}>
        <BookmarkButton />
      </Box>
    </BaseDrawer>
  );
};

export default ModelDrawerV2;
